import React from "react";

const PageHeading = ({
  title,
  subtitle,
  action,
  className = "np-admin-header-inner flex-grow-1",
  titleClassName = "np-admin-page-heading mb-0",
}) => (
  <header className={`d-flex justify-content-between align-items-center ${className}`.trim()}>
    <div>
      <h1 className={titleClassName}>{title}</h1>
      {subtitle && <small className="text-muted">{subtitle}</small>}
    </div>
    {action}
  </header>
);

export default PageHeading;
